import React from 'react';

const VipContext = React.createContext<boolean | undefined>(undefined);

export const VipProvider = ({ vip, children }: { vip?: boolean; children: React.ReactNode }) => (
  <VipContext.Provider value={vip}>{children}</VipContext.Provider>
);

export const useVipContext = () => React.useContext(VipContext);
